import { render, staticRenderFns } from "./eventGroupTournamentCard.vue?vue&type=template&id=bebbbc5c&scoped=true&"
import script from "./eventGroupTournamentCard.vue?vue&type=script&lang=js&"
export * from "./eventGroupTournamentCard.vue?vue&type=script&lang=js&"
import style0 from "./eventGroupTournamentCard.vue?vue&type=style&index=0&id=bebbbc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebbbc5c",
  null
  
)

export default component.exports